<!-- titulo -->
<section class="flex mb-4">
    <div class="flex-1 flex flex-col">
        <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
            Resumen de transacciones
        </span>
        <!-- <span class="flex span2 text-neutral-600 text-sm font-light font-['Inter'] leading-tight">
            
            @if (formattedCreatedAtFrom === formattedcreatedAtTo) {
                <p>Estás visualizando datos del día <span style="font-weight: 600;">{{ formattedCreatedAtFrom }}</span></p>
            } @else {
                <p>Estás visualizando datos desde <span style="font-weight: 600;">{{ formattedCreatedAtFrom }}</span> hasta el <span style="font-weight: 600;">{{ formattedcreatedAtTo }}</span></p>
            }

        </span> -->
    </div>
</section>
<!-- <app-card-info>
  <ng-template #titleTemplate>
   <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
     &nbsp;
   </span>
 </ng-template>
 <iframe width="100%" style="border: 0px;"
 src="{{quickSightUrl}}"
 ></iframe>
</app-card-info> -->

<!-- <section class="flex mb-6 flex-col"> -->
    <div class="flex-1" id="dashboardSalesContainer"></div>
<!-- </section> -->

<!--
<app-card-info titleClass="text-center flex">
    <ng-template #titleTemplate>
        <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
            Ventas generadas
        </span>
        <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
            Transacciones
        </span>
        <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
            Venta promedio
        </span>
    </ng-template>

</app-card-info>
-->
<!-- box resumen -->

<!-- <app-card-info titleClass="text-center flex">
    <ng-template #titleTemplate>
        <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
            Ventas generadas
        </span>
        <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
            Transacciones
        </span>
        <span class="flex-1 text-neutral-600 text-sm font-bold font-['Inter'] leading-loose">
            Venta promedio
        </span>
    </ng-template>
    <span class="flex-1 text-neutral-600 text-2xl font-bold font-['Inter']">
        @if (loader) {
            <ngx-skeleton-loader [theme]="{cursor: 'auto', width: '190px', height: '30px', margin: '0px'}" style="display: flex;  justify-content: center;"></ngx-skeleton-loader>
        } @else {
            $ 7.100.000 CLP
        }
    </span>
    
    <div class="flex-1 text-neutral-600 text-2xl font-bold font-['Inter'] border-x-2 border-indigo-50">
        @if (loader) {
            <ngx-skeleton-loader [theme]="{cursor: 'auto', width: '120px', height: '30px', margin: '0px'}" style="display: flex;  justify-content: center;"></ngx-skeleton-loader>
        } @else {
            <div class="inline-flex">
                <span class="mr-4">
                    1.000
                </span>
                <img width="20" src="../../../assets/img/sales/ic-sales-transactions.svg" />
            </div>
        }
    </div>
    <div class="flex-1 text-neutral-600 text-2xl font-bold font-['Inter']">
        @if (loader) {
            <ngx-skeleton-loader [theme]="{cursor: 'auto', width: '160px', height: '30px', margin: '0px'}" style="display: flex;  justify-content: center;"></ngx-skeleton-loader>
        } @else {
            $ 7.100 CLP
        }
    </div>
</app-card-info> -->

<!-- titulo transacciones -->
<!--
<section class="flex mb-6 flex-col">
    <div class="flex mb-7">
        <span class="flex-1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
            Transacciones
        </span>
        @if (loader) {
            <div class="inline-flex">
                <div role="status" class="pr-4">
                    <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-indigo-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg>
                </div>
    
                <div id="transacciones-resumen" class="text flex gap-2 text-indigo-400 text-[14px] font-semibold font-['Poppins'] leading-none tracking-tight " style="align-items: center;">
                    Estamos cargando la información de tus transacciones.
                </div>
            </div>
        }
    </div>
    <div class="flex flex-col">
        <div class="borde-1 bg-white py-3 text-center shadow-1 mb-4 flex">
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Fecha y hora
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Monto
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Método de pago
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Tipo de tarjeta
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Número de operación
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Tipo de operación
            </span>
            <#!-- <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Canal
            </span> --#>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal border-e-2 border-indigo-50">
                Estado de venta
            </span>
            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Inter'] leading-normal">
                Detalle
            </span>
        </div>

        @if (loader) {
            <p-dataView #dv [value]="transactionsLoading" [rows]="8" [paginator]="true">
                <ng-template let-transactionsLoading pTemplate="list">
                    @for (item of transactionsLoading; track item.id) {
                        <div class="borde-2 bg-white py-3 text-center items-center shadow-1 mb-2 flex">
                            <span class="loading px-3 flex-1 border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                            <#!-- <span class="loading px-3 flex-1  border-e-2 border-indigo-50">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span> --#>
                            <span class="loading px-3 flex-1 ">
                                <ngx-skeleton-loader [theme]="{cursor: 'auto'}"></ngx-skeleton-loader>
                            </span>
                        </div>
                    }

                </ng-template>
            </p-dataView>
        } @else {
            <p-dataView #dv [value]="transactions" [rows]="8" [paginator]="true">
                <ng-template let-transactions pTemplate="list">
                    @for (item of transactions; track item.id) {
                        <div class="borde-2 bg-white py-3 text-center items-center shadow-1 mb-2 flex">
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ item.created_at_time_zone | date: 'dd-MM-yyyy - HH:mm:ss' }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.currencyFormat(item.amount) }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                <div class="inline-flex">
                                    @if(item.network == 'VISA') {
                                        <div class="inline-block rounded-sm items-center" style="display: flex; align-items: center;">
                                            <img class="w-[18px]" src="../../../assets/img/sales/ic-visa2.svg" />
                                        </div>
                                    } @else {
                                        <div class="inline-block rounded-sm items-center" style="display: flex; align-items: center;">
                                            <img class="w-[18px]" src="../../../assets/img/sales/ic-mastercard2.svg" />
                                        </div>
                                    }
                                    <span class="ms-1">{{ item.masked_card_number }}</span>
                                </div>
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.creditCardType(item.type) }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ item.operation_number }}
                            </span>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ normalizeDataService.operationType(item.operation_type) }}
                            </span>
                            <#!-- <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                {{ item.channel }}
                            </span> --#>
                            <span class="flex-1 text-slate-600 text-[10px] font-normal font-['Poppins'] leading-normal border-e-2 border-indigo-50">
                                @switch (item.status) {
                                    @case ('succeeded') {
                                        <app-badges text="Aprobada"></app-badges>
                                    }
                                    @case ('SUCCESS') {
                                        <app-badges text="Aprobada"></app-badges>
                                    }
                                    @case ('processing') {
                                        <app-badges text="Cancelado" bgColor="bg-yellow-400"></app-badges>
                                    }
                                    @case ('error') {
                                        <app-badges text="Rechazado" bgColor="bg-red-500"></app-badges>
                                    }
                                    @case ('ERROR') {
                                        <app-badges text="Rechazado" bgColor="bg-red-500"></app-badges>
                                    }
                                }
                            </span>
                            <span class="flex-1 text-neutral-600 text-xs font-semibold font-['Poppins'] leading-normal">
                                <a (mousedown)="handleMouseDown(item.channel, item.id, item.operation_type, $event)" (click)="handleClickChannel(item.channel, item.id, item.operation_type, $event)" [routerLink]="'/transacciones/' + item.id" class="text-indigo-400 text-[10px] font-medium font-['Poppins'] leading-none tracking-tight">
                                    Ver detalles
                                    <img class="inline ms-1" src="../../../assets/img/sales/ic-arrow-detalle.svg" />
                                </a>
                            </span>
                        </div>
                    }
                </ng-template>
            </p-dataView>
        }
    </div>
</section>
-->